import * as React from 'react';

// Material-UI
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';

// Routing
import { Navigate, Outlet } from 'react-router-dom';

// OBVM Components
import Navigator from '../components/navigator';
import Header from '../components/header';
import Footer from '../components/footer';

const headerHeight = 50;

let theme = createTheme({
	palette: {
		primary: {
			light: '#D8D7D6',
			main: '#B1282E',
			dark: '#0F1820',
		},
	},
	typography: {
		h5: {
			fontWeight: 50,
			fontSize: 26,
			letterSpacing: 0.5,
		},
	},
	shape: {
		borderRadius: 8,
	},
	components: {
		MuiTab: {
			defaultProps: {
				disableRipple: true,
			},
		},
	},
	mixins: {
		toolbar: {
			height: headerHeight,
		},
	},
});

theme = {
	...theme,
	components: {
		MuiDrawer: {
			styleOverrides: {
				paper: {
					backgroundColor: '#0F1820',
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'none',
				},
				contained: {
					boxShadow: 'none',
					'&:active': {
						boxShadow: 'none',
					},
				},
			},
		},
		MuiListItemText: {
			styleOverrides: {
				primary: {
					fontSize: 14,
					fontWeight: theme.typography.fontWeightMedium,
				},
			},
		},
		MuiListItemIcon: {
			styleOverrides: {
				root: {
					color: 'inherit',
					minWidth: 'auto',
					marginRight: theme.spacing(2),
					'& svg': {
						fontSize: 20,
					},
				},
			},
		},
	},
};

export default function HeaderNavBase() {
	const [mobileOpen, setMobileOpen] = React.useState(false);
	// const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	return (
		<ThemeProvider theme={theme}>
			<Header onDrawerToggle={handleDrawerToggle} drawerIcon={true} title="Online Battery Validation Manager" />
			<Box style={{ display: 'flex', height: `calc(100vh - ${theme.mixins.toolbar.height}px)` }}>
				<CssBaseline />
				<Navigator mobileOpen={mobileOpen} onDrawerToggle={handleDrawerToggle} />
				<Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
					<Box component="main" sx={{ flex: 1.2, py: 1.2, px: 1, bgcolor: '#D8D7D6' }}>
						<Box
							sx={{
								borderRadius: 1,
								bgcolor: '#FFFFFF',
								padding: 1,
								boxShadow: 7,
								height: '100%',
							}}
						>
							<Outlet />
						</Box>
					</Box>
					<Footer />
				</Box>
			</Box>
		</ThemeProvider>
	);
}
